import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Global } from '../global/globalApi';
import { RootScopeService } from '../services/root-scope.service';
import * as Constants from 'src/app/models/Constants';

export const AuthGuard: CanActivateFn = (): boolean => {
  const rootScope = inject(RootScopeService);
  const router = inject(Router);

    rootScope.isAuthenticated().subscribe((res) => {
      rootScope.isAuthenticate = res;
    });

  if (!sessionStorage.getItem('userSession') && !rootScope.launchAppFromManualLogin) {
    const currentURL = window.location.href;
    if (currentURL.includes(Constants.LOCAL_ANGULAR_APIURL)) {
      /* istanbul ignore next line */
      router.navigate(['login']);
      return false;
    } else {
      window.location.href = `${Global.domainUrl}awcp/oauth2/authorization/pingidentity`;
      return false;
    }
  } else if (rootScope.isSSODuplicate || rootScope.launchAppBySSO) {
    return true;
  } else if (!rootScope.launchAppFromManualLogin && !sessionStorage.getItem('userSession')) {
    /* istanbul ignore next line */
    router.navigate(['login']);
    return false;
  }
   rootScope.isAuthenticate = true;
  return true;
};

